/*
 * Wuselzeit — Footer-Links: Widerruf und Sendungsverfolgung
 *
 * Widerruf (§ 356a BGB, Pflicht seit 19.06.2026): Das Gesetz verlangt eine
 * gut lesbare, hervorgehobene Fläche "Vertrag widerrufen", die von JEDER
 * Seite aus ständig erreichbar ist, ohne Anmeldung.
 *
 * Sendungsverfolgung: Eine Trackingseite, die niemand findet, spart keine
 * einzige "Wo ist mein Paket?"-Mail. Deshalb steht sie dort, wo Kunden
 * danach suchen — im Footer, auf jeder Seite.
 *
 * Cookie-Einstellungen (seit 28.09.2026): Der Cookie-Banner verspricht
 * "Deine Wahl kannst du jederzeit ändern" — der Widerruf muss so einfach sein
 * wie die Einwilligung (Art. 7 Abs. 3 DSGVO). Der Knopf öffnet Shopifys
 * eigene Einstellungen; ohne Banner-Script führt er zur Datenschutzerklärung.
 *
 * Alles hängt hier per Script am Footer statt in einer Theme-Datei — so
 * überlebt es Theme-Updates.
 */
(function () {
  'use strict';

  var BASIS = (window.WUSELZEIT_CHECKOUT_URL || 'https://checkout.wuselzeit.de/checkout')
    .replace(/\/checkout$/, '');

  function einhaengen() {
    if (document.getElementById('wuselzeit-widerruf')) return;

    var box = document.createElement('div');
    box.id = 'wuselzeit-widerruf';
    box.style.cssText = 'text-align:center;padding:14px 16px;';

    var link = document.createElement('a');
    link.href = BASIS + '/widerruf';
    link.textContent = 'Vertrag widerrufen';
    // Hervorgehoben, wie § 356a es verlangt: Rahmen und fette Schrift,
    // nicht bloß ein grauer Textlink zwischen anderen.
    link.style.cssText =
      'display:inline-block;padding:9px 18px;border:1.5px solid currentColor;' +
      'border-radius:8px;font-weight:600;text-decoration:none;color:inherit;';

    box.appendChild(link);

    // Bewusst unauffälliger als der Widerrufsbutton: Der ist gesetzlich
    // hervorzuheben, die Sendungsverfolgung soll ihm nicht die Aufmerksamkeit
    // wegnehmen.
    var sendung = document.createElement('div');
    sendung.style.cssText = 'margin-top:10px;font-size:14px;';
    var sLink = document.createElement('a');
    sLink.href = BASIS + '/sendung';
    sLink.textContent = 'Sendung verfolgen';
    sLink.style.cssText = 'color:inherit;text-decoration:underline;text-underline-offset:2px;opacity:.85;';
    sendung.appendChild(sLink);
    box.appendChild(sendung);

    // Ein Knopf, kein Link: Er öffnet einen Dialog, statt wegzuführen. Optisch
    // wie "Sendung verfolgen".
    var cookies = document.createElement('div');
    cookies.style.cssText = 'margin-top:6px;font-size:14px;';
    var knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.setAttribute('data-wuselzeit-cookies', '');
    knopf.textContent = 'Cookie-Einstellungen';
    knopf.style.cssText = 'background:none;border:0;padding:0;font:inherit;cursor:pointer;' +
      'color:inherit;text-decoration:underline;text-underline-offset:2px;opacity:.85;';
    knopf.addEventListener('click', function () {
      var banner = window.privacyBanner;
      if (banner && typeof banner.showPreferences === 'function') {
        banner.showPreferences();
      } else {
        window.location.assign('/policies/privacy-policy');
      }
    });
    cookies.appendChild(knopf);
    box.appendChild(cookies);

    var footer = document.querySelector('footer') || document.body;
    footer.appendChild(box);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', einhaengen);
  } else {
    einhaengen();
  }
})();
